import { render, staticRenderFns } from "./nomal_pause.vue?vue&type=template&id=857d25c4&scoped=true"
import script from "./nomal_pause.vue?vue&type=script&lang=js"
export * from "./nomal_pause.vue?vue&type=script&lang=js"
import style0 from "./nomal_pause.vue?vue&type=style&index=0&id=857d25c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857d25c4",
  null
  
)

export default component.exports